import React from 'react';
import { TextV2 } from '@withjoy/joykit';

type HiddenLabelProps = Readonly<{
  label: string;
}>;

export const HiddenLabel: React.FC<HiddenLabelProps> = ({ label }) => {
  return (
    <TextV2
      typographyVariant="label1"
      color="mono8"
    >
      {label}
    </TextV2>
  );
};
